// extracted by mini-css-extract-plugin
module.exports = {"fields":"wC0HkL","time":"X6_yl2","mobile":"fGIRhy"};